export const ClientProfile = (json: IClientProfile): IClientProfileModel => {
	const fromJSON = () => {
		const { phone_number, email_verified_at, email_verification_token, first_name, last_name, client_id, ...rest } =
			json
		return {
			clientID: client_id,
			firstName: first_name,
			lastName: last_name,
			phoneNumber: phone_number,
			emailVerifiedAt: email_verified_at ? new Date(email_verified_at) : null,
			emailVerificationToken: email_verification_token,
			...rest,
		}
	}

	return { ...fromJSON() }
}

export const clientProfileToJSON = (obj: Partial<IClientProfileModel>): Partial<IClientProfile> => {
	const { phoneNumber, ...rest } = obj
	return {
		phone_number: phoneNumber,
		...rest,
	}
}

export const clientFromJSON = (json: IClient): IClientModel => {
	const fromJSON = () => {
		const {
			first_name,
			last_name,
			created_at,
			marketing_consent,
			client,
			mail_communication_consent,
			sms_communication_consent,
			birth_date,
			...rest
		} = json
		return {
			firstName: first_name,
			lastName: last_name,
			createdAt: created_at ? new Date(created_at) : null,
			marketingConsent: marketing_consent,
			client: client ? ClientProfile(client) : null,
			mailCommunicationConsent: mail_communication_consent,
			smsCommunicationConsent: sms_communication_consent,
			birthDate: birth_date ? new Date(birth_date) : null,
			...rest,
		}
	}

	return { ...fromJSON() }
}

export const clientToJSON = (obj: Partial<IClientModel>): Partial<IClient> => {
	const { firstName, lastName, client, phoneNumber, birthDate, ...rest } = obj
	return {
		first_name: firstName,
		last_name: lastName,
		client: client ? clientProfileToJSON(client) : undefined,
		phone_number: phoneNumber ? phoneNumber : undefined,
		birth_date: birthDate ? birthDate : undefined,
		...rest,
	}
}

export const ClientAddress = (json: IClientAddress): IClientAddressModel => {
	const {
		is_assigned,
		building_type,
		building_number,
		apartment_number,
		entry_code,
		delivery_until,
		delivery_place,
		courier_instructions,
		updated_at,
		created_at,
		delivery_phone_number,
		is_alternative_delivery_phone_number,
		...rest
	} = json

	return {
		...rest,
		isAssigned: is_assigned,
		buildingType: building_type,
		buildingNumber: building_number,
		apartmentNumber: apartment_number,
		deliveryUntil: delivery_until,
		deliveryPlace: delivery_place,
		courierInstructions: courier_instructions,
		entryCode: entry_code,
		deliveryPhoneNumber: delivery_phone_number,
		isAlternativeDeliveryPhoneNumber: is_alternative_delivery_phone_number,
		updatedAt: updated_at ? new Date(updated_at) : null,
		createdAt: created_at ? new Date(created_at) : null,
	}
}

export const ClientAddressFormToJson = (obj: IClientAddressFormModel): IClientAddressFormJson => {
	const {
		apartmentNumber,
		buildingNumber,
		buildingType,
		courierInstructions,
		deliveryPlace,
		deliveryUntil,
		entryCode,
		deliveryPhoneNumber,
		isAlternativeDeliveryPhoneNumber,
		...rest
	} = obj

	return {
		...rest,
		apartment_number: apartmentNumber,
		building_number: buildingNumber,
		building_type: buildingType,
		courier_instructions: courierInstructions,
		delivery_place: deliveryPlace,
		delivery_until: deliveryUntil,
		entry_code: entryCode,
		delivery_phone_number: deliveryPhoneNumber ? deliveryPhoneNumber.split(' ').join('') : null,
		is_alternative_delivery_phone_number: isAlternativeDeliveryPhoneNumber,
	}
}

export const ClientAddressManageToJson = (obj: IClientAddressCreateModel): IClientAddressCreateJson => {
	const { clientUUID, ...rest } = obj

	return {
		...ClientAddressFormToJson(rest),
		client_uuid: clientUUID,
	}
}

export const ClientRating = (json: IClientRating): IClientRatingModel => {
	const { diet, meal, order_number, ...rest } = json

	return {
		...rest,
		diet: {
			kcal: diet.kcal,
			name: LangContentToModel(diet.name),
		},
		meal: LangContentToModel(meal),
		orderNumber: order_number,
	}
}
